import React from 'react';
import styles from '../TaskDescriptionField.module.css';
import { RichTextDescription } from '../index';
import { RotateCcw } from 'lucide-react';
import { MarkdownMentionPreviewContext } from '../types';

export const Editor = ({
  show,
  footerActions,
  value,
  placeholder,
  fullHeight,
  fixedWidthDetailsToolbarColumn,
  undoValue,
  handleDetailsSave,
  handleUndo,
  mentionOrDerived,
  getContainer
}: {
  show: boolean;
  footerActions?: React.ReactNode;
  value: string;
  placeholder: string;
  fullHeight: boolean;
  fixedWidthDetailsToolbarColumn: boolean;
  undoValue: string | null;
  handleDetailsSave: (value: string) => void;
  handleUndo: () => void;
  mentionOrDerived: MarkdownMentionPreviewContext | undefined;
  getContainer?: () => HTMLElement;
}) => {
  if (!show) return null;

  return (
    <RichTextDescription
      footerLeadingActions={
        undoValue !== null && (
          <button
            type="button"
            className={styles.tdfUndoButton}
            onClick={handleUndo}
            title="Restore the description to what it was before your last save"
          >
            <RotateCcw size={11} />
            Restore previous
          </button>
        )
      }
      footerActions={footerActions}
      value={value}
      onChange={handleDetailsSave}
      placeholder={placeholder}
      fullHeight={fullHeight}
      shortcutConfig={null}
      detailsMode
      saveOnBlur
      mentionRenderContext={mentionOrDerived ?? null}
      fixedWidthDetailsToolbarColumn={fixedWidthDetailsToolbarColumn}
      getContainer={getContainer}
    />
  );
};
